interface Props {
  regionName: string;
  compCount: number;
  addedCount: number;
  error: string | null;
  onCancel: () => void;
  onSave: () => void;
}

/** Title + working-set count + cancel/save, with the composition error banner. */
export function BuilderHeader({
  regionName,
  compCount,
  addedCount,
  error,
  onCancel,
  onSave,
}: Props) {
  return (
    <>
      <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
        <h2
          className="nb-display"
          style={{ margin: 0, fontSize: 19, color: 'var(--nb-bark-dark)' }}
        >
          Edit {regionName}
        </h2>
        <span style={{ flex: 1 }} />
        <span style={{ fontSize: 12, color: 'var(--nb-subtle)' }}>
          {compCount} geograph{compCount === 1 ? 'y' : 'ies'}
          {addedCount > 0 && ` · ${addedCount} new`}
        </span>
        <button className="nb-btn" onClick={onCancel}>
          Cancel
        </button>
        <button className="nb-btn nb-btn-primary" onClick={onSave}>
          Review &amp; save
        </button>
      </div>

      {error && (
        <div
          role="alert"
          style={{
            padding: '10px 14px',
            borderRadius: 9,
            background: 'var(--nb-warn-soft)',
            color: 'var(--nb-warn)',
            fontSize: 12.5,
          }}
        >
          {error}
        </div>
      )}
    </>
  );
}
